export const checkModalOrDrawerVisible = (): boolean => {
  // 如果不在浏览器环境，直接返回 false
  if (typeof document === 'undefined') {
    return false;
  }

  // 检查 Modal
  const modalMask = document.querySelector('.ant-modal-mask');
  const modalVisible = document.querySelector('.ant-modal-wrap:not(.ant-modal-hidden)');

  // 检查 Drawer
  const drawerMask = document.querySelector('.ant-drawer-mask');
  const drawerVisible = document.querySelector('.ant-drawer-open');

  return !!((modalMask && modalVisible) || (drawerMask && drawerVisible));
};
